import { MenuItem, TextField } from '@mui/material';
import { rotuloSemestre } from './types';

/** Escolha do semestre; só aparece quando há mais de um. */
export function SeletorSemestre({
  semestres,
  valor,
  onChange,
}: {
  semestres: string[];
  valor: string | null;
  onChange: (s: string) => void;
}) {
  if (semestres.length < 2 || !valor) return null;
  return (
    <TextField
      select
      size="small"
      label="Semestre"
      value={valor}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth: 140 }}
    >
      {semestres.map((s) => (
        <MenuItem key={s} value={s}>
          {rotuloSemestre(s)}
        </MenuItem>
      ))}
    </TextField>
  );
}
